module.exports = __webpack_public_path__ + "img/Multiple_sequence_alignment_2.03bbf7f8.jpg";